import { FormattedMessage } from 'react-intl';
import { UpdateParameterFunction } from '../../hooks/ParametersHooks';
import { User, UserParameters } from '../../model/models';
import { DirectoryParameters } from '../profile/parameters/DirectoryParameters';
import { InterstsParameters } from '../profile/parameters/InterestsParameters';
import { LanguageParameters } from '../profile/parameters/LanguageParameters';
import { NotificationsParameters } from '../profile/parameters/NotificationsParameters';
import { PhotoParameters } from '../profile/parameters/PhotoParameters';
import { TagParameters } from '../profile/parameters/TagParameters';

import ActusImage from '../../theme/img/wizard/Actus.png';
import AnnuaireImage from '../../theme/img/wizard/Annuaire.png';
import EventsImage from '../../theme/img/wizard/Events.png';
import ProfilImage from '../../theme/img/wizard/Profil.png';
import IdentificationImage from '../../theme/img/wizard/Identification.png';
import { Step } from '../../model/wizard/wizard';

type StepElement = {
  slug: Step;
  title: JSX.Element;
  description: JSX.Element;
  image: string;
  component: React.FC<ParametersProps> | null;
};

export interface ParametersProps {
  user: User;
  updateParameter: UpdateParameterFunction;
  parameters: UserParameters;
  isSetLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const getWizardStep = (step: Step, user: User): StepElement | null => {
  switch (step) {
    case 'language':
      return {
        slug: 'language',
        title: (
          <>
            <FormattedMessage id="hello" />
            <span className="text-primary"> {user?.first_name} !</span>
          </>
        ),
        description: (
          <>
            <p className="text-center font-bold text-gray-600 ">
              <FormattedMessage id="Config profile" />
            </p>
            <p className="text-center">
              <FormattedMessage id="Start with language" />
            </p>
          </>
        ),
        image: ActusImage,
        component: LanguageParameters,
      };
    case 'photo':
      return {
        slug: 'photo',
        title: <FormattedMessage id="Profile picture" />,
        description: (
          <p className="text-center">
            <FormattedMessage id="Profile picture info" />
          </p>
        ),
        image: IdentificationImage,
        component: PhotoParameters,
      };
    case 'cursus':
      return {
        slug: 'cursus',
        title: <FormattedMessage id="My curriculum" />,
        description: (
          <div>
            <p className="text-center">
              <FormattedMessage id="My curriculum description" />
            </p>
          </div>
        ),
        image: ProfilImage,
        component: TagParameters,
      };
    case 'notifications':
      return {
        slug: 'notifications',
        title: <FormattedMessage id="Notifications" />,
        description: (
          <div className="flex flex-col justify-between">
            <div>
              <p className="text-center">
                <FormattedMessage id="Notif description" />
              </p>
            </div>
            <div className="mt-8">
              <p className="text-center font-bold text-gray-500">
                <FormattedMessage id="Notif question" />
              </p>
            </div>
          </div>
        ),
        image: ActusImage,
        component: NotificationsParameters,
      };
    case 'annuaire':
      return {
        slug: 'annuaire',
        title: <FormattedMessage id="Directory" />,
        description: (
          <div className="flex flex-col justify-between">
            <p className="text-center">
              <FormattedMessage id="Directory description" />
            </p>
            <p className="text-center font-bold text-gray-500">
              <FormattedMessage id="Directory question" />
            </p>
          </div>
        ),
        image: AnnuaireImage,
        component: DirectoryParameters,
      };
    case 'interests':
      return {
        slug: 'interests',
        title: <FormattedMessage id="Interests" />,
        description: (
          <p className="text-center text-gray-500">
            <FormattedMessage
              id="Interests description"
              values={{
                b: (text) => <b>{text}</b>,
              }}
            />
          </p>
        ),
        image: ActusImage,
        component: InterstsParameters,
      };
    case 'done':
      return {
        slug: 'done',
        title: (
          <div className="flex flex-col justify-center items-center">
            <div className="bg-primary rounded-full w-24 h-24 flex justify-center items-center mb-5">
              <svg
                width="35"
                height="35"
                viewBox="0 0 41 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38 3L14.5236 36.5328C14.2138 36.9778 13.8027 37.3429 13.3242 37.5979C12.8456 37.8529 12.3133 37.9906 11.7712 37.9995C11.229 38.0085 10.6924 37.8885 10.2057 37.6494C9.71899 37.4104 9.29607 37.0591 8.97178 36.6245L3 28.664"
                  stroke="white"
                  strokeWidth="6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <FormattedMessage id="Done" />
          </div>
        ),
        description: (
          <div className="text-center text-gray-500">
            <FormattedMessage
              id="Done description"
              values={{
                b: (text) => <b>{text}</b>,
              }}
            />
          </div>
        ),
        image: EventsImage,
        component: null,
      };
    default:
      return null;
  }
};
